import type { ReactNode } from 'react';

/**
 * Каркас экрана: шапка, прокручиваемое содержимое, нижняя часть.
 *
 * Прокрутка живёт **внутри** содержимого, а не на странице: иначе в установленной PWA
 * тянется вся страница целиком и это сразу читается как «сайт». Инерция внутри списка
 * при этом остаётся — `overscroll-behavior-y: contain`, а не `none`.
 */
export function AppScreenScaffold({
  topBar,
  children,
  bottomBar,
  overlay,
}: {
  topBar?: ReactNode;
  children: ReactNode;
  bottomBar?: ReactNode;
  overlay?: ReactNode;
}) {
  return (
    <div className="screen">
      {topBar}
      <div className="screen__content">{children}</div>
      {bottomBar}
      {overlay}
    </div>
  );
}
